export default __webpack_public_path__ + "static/media/upload-file.02ecc254.svg";